import React from 'react';
import Column from '@amzn/meridian/column';
import Text from '@amzn/meridian/text';
import { SSD_FEATURE_FLAGS_LIST } from '../../../../utils/constants';
import { isFeatureFlagEnabled } from '../../utils';
import NavigationButtons from '../../../commonComponents/NavigationButtons';

import {
  HeadcountShiftSingleBusiness,
  HeadcountShiftMultiBusiness,
  HeadcountHourlySingleBusiness,
  HeadcountHourlyMultiBusiness
} from './VerifyHeadcountComponents';

const HEADCOUNT_FLOWS = {
  SHIFT_SINGLE_BUSINESS: 'shiftSingleBusiness',
  SHIFT_MULTI_BUSINESS: 'shiftMultiBusiness',
  HOURLY_SINGLE_BUSINESS: 'hourlySingleBusiness',
  HOURLY_MULTI_BUSINESS: 'hourlyMultiBusiness'
};

const getFlow = (isNarrowWindowsEnabled, isGroceryEnabled) => {
  if (isNarrowWindowsEnabled && isGroceryEnabled) return HEADCOUNT_FLOWS.HOURLY_MULTI_BUSINESS;
  if (isNarrowWindowsEnabled) return HEADCOUNT_FLOWS.HOURLY_SINGLE_BUSINESS;
  if (isGroceryEnabled) return HEADCOUNT_FLOWS.SHIFT_MULTI_BUSINESS;
  return HEADCOUNT_FLOWS.SHIFT_SINGLE_BUSINESS;
};

const HEADCOUNT_COMPONENT_MAP = {
  [HEADCOUNT_FLOWS.SHIFT_SINGLE_BUSINESS]: HeadcountShiftSingleBusiness,
  [HEADCOUNT_FLOWS.SHIFT_MULTI_BUSINESS]: HeadcountShiftMultiBusiness,
  [HEADCOUNT_FLOWS.HOURLY_SINGLE_BUSINESS]: HeadcountHourlySingleBusiness,
  [HEADCOUNT_FLOWS.HOURLY_MULTI_BUSINESS]: HeadcountHourlyMultiBusiness
};

const VerifyHeadcounts = ({ currentUser, plan, setPlan, onGoBack, onGoNext, onCancel }) => {
  const isGroceryEnabled = isFeatureFlagEnabled(plan.input.adminSettings, SSD_FEATURE_FLAGS_LIST.groceryEnabled);
  const isNarrowWindowsEnabled = isFeatureFlagEnabled(
    plan.input.adminSettings,
    SSD_FEATURE_FLAGS_LIST.narrowWindowsEnabled
  );
  const flow = getFlow(isNarrowWindowsEnabled, isGroceryEnabled);
  const HeadcountComponent = HEADCOUNT_COMPONENT_MAP[flow];

  return (
    <Column width="100%">
      <Text type={'h400'}>Headcount</Text>
      <Text type={'b400'}>Verify or update the values below and submit.</Text>
      <HeadcountComponent currentUser={currentUser} plan={plan} setPlan={setPlan} />
      <NavigationButtons onBack={onGoBack} onNext={onGoNext} onCancel={onCancel} showCancel={true} />
    </Column>
  );
};

export default VerifyHeadcounts;
